// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
}
.modal-title ion-icon {
  font-size: 19px;
  opacity: 0.88;
}

.map-form-content {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  display: flex;
  flex-direction: column;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 16px 10px;
  flex: 1;
}

.field-group {
  display: flex;
  flex-direction: column;
}
.field-group ion-input.styled-input,
.field-group ion-textarea.styled-input {
  width: 100%;
  font-size: var(--font-size-small);
}

.path-field {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1.5px solid rgba(var(--ion-color-medium-rgb), 0.3);
  background: var(--ion-background-color, #fff);
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}
.path-field:hover {
  border-color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.03);
}
.path-field .path-icon {
  font-size: 22px;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}
.path-field .path-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.path-field .path-text .path-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--ion-color-medium);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.path-field .path-text .path-value {
  font-size: var(--font-size-small);
  color: var(--ion-color-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.path-field .path-text .path-value.has-path {
  color: var(--ion-color-dark);
  font-weight: 500;
}
.path-field .arrow-icon {
  font-size: 18px;
  color: var(--ion-color-medium);
  flex-shrink: 0;
}

.form-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 10px 14px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/trajectory-creation/select-region-area/components/new-region-map-form/new-region-map-form.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AADF;AAGE;EACE,eAAA;EACA,aAAA;AADJ;;AAOA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAJF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,OAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;AANF;AAQE;;EAEE,WAAA;EACA,iCAAA;AANJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,0DAAA;EACA,6CAAA;EACA,eAAA;EACA,0DAAA;AATF;AAWE;EACE,sCAAA;EACA,oDAAA;AATJ;AAYE;EACE,eAAA;EACA,+BAAA;EACA,cAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,qBAAA;AAXN;AAcI;EACE,iCAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAZN;AAcM;EACE,4BAAA;EACA,gBAAA;AAZR;AAiBE;EACE,eAAA;EACA,8BAAA;EACA,cAAA;AAfJ;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,uBAAA;EACA,yCAAA;EACA,cAAA;AAlBF","sourcesContent":["// ── New Region Map Form — matches select-region-area design language ───────\r\n\r\n.modal-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n\r\n  ion-icon {\r\n    font-size: 19px;\r\n    opacity: 0.88;\r\n  }\r\n}\r\n\r\n// ── Content shell ────────────────────────────────────────────────────────\r\n\r\n.map-form-content {\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n// ── Form body ─────────────────────────────────────────────────────────────\r\n\r\n.form-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 16px 16px 10px;\r\n  flex: 1;\r\n}\r\n\r\n.field-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  ion-input.styled-input,\r\n  ion-textarea.styled-input {\r\n    width: 100%;\r\n    font-size: var(--font-size-small);\r\n  }\r\n}\r\n\r\n// ── Path picker row ───────────────────────────────────────────────────────\r\n\r\n.path-field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 14px;\r\n  border-radius: 10px;\r\n  border: 1.5px solid rgba(var(--ion-color-medium-rgb), 0.3);\r\n  background: var(--ion-background-color, #fff);\r\n  cursor: pointer;\r\n  transition: border-color 0.18s ease, background 0.18s ease;\r\n\r\n  &:hover {\r\n    border-color: var(--ion-color-primary);\r\n    background: rgba(var(--ion-color-primary-rgb), 0.03);\r\n  }\r\n\r\n  .path-icon {\r\n    font-size: 22px;\r\n    color: var(--ion-color-primary);\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .path-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n    flex: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n\r\n    .path-label {\r\n      font-size: 10px;\r\n      font-weight: 700;\r\n      color: var(--ion-color-medium);\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.5px;\r\n    }\r\n\r\n    .path-value {\r\n      font-size: var(--font-size-small);\r\n      color: var(--ion-color-medium);\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n\r\n      &.has-path {\r\n        color: var(--ion-color-dark);\r\n        font-weight: 500;\r\n      }\r\n    }\r\n  }\r\n\r\n  .arrow-icon {\r\n    font-size: 18px;\r\n    color: var(--ion-color-medium);\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n// ── Footer ────────────────────────────────────────────────────────────────\r\n\r\n.form-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  padding: 10px 14px 14px;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\r\n  flex-shrink: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
